import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import apiClient from "../Config/apiConfig";
import { LineWave } from "react-loader-spinner";
const config = {
    BASE_URL: "https://admin.thezeeshangroup.com/",
};
const Projectcategories = () => {
    const [getProjectCategoriesData, setGetProjectCategoriesData] = useState([]);
    const [loader, setLoader] = useState(true);
    const projectcategoriesApi = async () => {
        try {
            const res = await apiClient.get(`api/project-categories`);
            setLoader(true);
            setGetProjectCategoriesData(res.data);
            setLoader(false);
        } catch (error) {
            console.log(error.message);
        }
    };
    useEffect(() => {
        projectcategoriesApi();
    }, []);
    return (
        <>
            <Col sm="12">
                {loader ? (
                    <div className="d-flex justify-content-center">
                        <LineWave
                            height="250"
                            width="150"
                            color="#56b13d"
                            ariaLabel="line-wave"
                        />
                    </div>
                ) : (
                    <ul>
                        {getProjectCategoriesData.map((item, i) => {
                            return (
                                <>
                                    <li>
                                        <a href="/">
                                            <img src={`${config.BASE_URL}uploads/projectcategories/${item.image}`} alt={item.name} />
                                            <div className="text-desc">
                                                <p>{item.name}</p>
                                            </div>
                                        </a>
                                    </li>
                                </>
                            );
                        })}
                    </ul>
                )}
            </Col>
        </>
    );
};

export default Projectcategories;
